import { render } from "./TextIcon.svg?vue&type=template&id=e3750182"
const script = {}
script.render = render

export default script